
const createStatusRequest = (acao) => {
    return {
        SUCCESS: acao + '_SUCCESS',
        ERROR: acao + '_ERROR',
        LOADING: acao + '_LOADING'
    }
};

const CONSTANTS = {
    SET_ERROR: 'SET_ERROR',
    SET_MSG: 'SET_MSG',
    CHANGE_GENERICO: 'CHANGE_GENERICO',
    CARREGAR_QUESTOES: createStatusRequest('CARREGAR_QUESTOES'),
    SETAR_SIM_NAO: 'SETAR_SIM_NAO',
    CHANGE_TEXTO_OUTROS: 'CHANGE_TEXTO_OUTROS',
    GRAVAR_RESPOSTAS: createStatusRequest('GRAVAR_RESPOSTAS'),
    CARREGAR_LIST_CIDADES: createStatusRequest('CARREGAR_LIST_CIDADES'),
    CARREGAR_AREAS: createStatusRequest('CARREGAR_AREAS'),
    CHANGE_GENERICO_SOLICITANTE: 'CHANGE_GENERICO_SOLICITANTE',
    CHANGE_AREA: 'CHANGE_AREA',
    CONSULTA_CEP: createStatusRequest('CONSULTA_CEP'),
    GET_PESSOA_DADOS: createStatusRequest('GET_PESSOA_DADOS'),
    GRAVAR_SOLICITANTE: createStatusRequest('GRAVAR_SOLICITANTE'),  
    VERIFICA_LIBERACAO: createStatusRequest('VERIFICA_LIBERACAO'),      
    RESET_SOLICITANTE: 'RESET_SOLICITANTE',       
};

export default CONSTANTS;